module.exports = __webpack_public_path__ + "media/common/images/badges/active/mas_jiskru-dbe2e1f37682dcd18992534c4f99f1e6.svg";